import axios from 'axios';
import {apiError, error} from "./errors";

const modifyResponse = (r, dispatch, actionTypes) => {
  return new Promise((resolve) => {
    if (r.data && r.data.success)
      return resolve(r.data);

    if (dispatch && typeof dispatch === 'function')
      apiError(r.data, dispatch, actionTypes.rejected);
    return false;
  })
};

export default {
  get: (url, dispatch, actionTypes) => {
    if (dispatch && typeof dispatch === 'function')
      dispatch({type: actionTypes.pending});

    return axios({
      method: 'get',
      url,
      headers: {
        'Content-type': 'application/json'
      }
    })
      .then((res) => {
        return modifyResponse(res, dispatch, actionTypes)
      })
      .catch((err) => {
        error(err, dispatch, actionTypes.rejected);
        return Promise.reject();
      });
  },

  post: (url, data, dispatch, actionTypes) => {
    if (dispatch && typeof dispatch === 'function')
      dispatch({type: actionTypes.pending});

    return axios.post(url, data, {
      headers: {
        'Content-type': 'application/json'
      }
    })
      .then((res) => {
        return modifyResponse(res, dispatch, actionTypes)
      })
      .catch((err) => {
        error(err, dispatch, actionTypes.rejected);
        return Promise.reject();
      })
  },

  formData: (url, data, dispatch, actionTypes) => {
    console.log('TEST DATA', data);
    const fd = new FormData();
    for (let i = 0; i < Object.keys(data).length; i++) {
      const val = data[Object.keys(data)[i]];
      if (Object.keys(data)[i] === 'images' && typeof val === 'object') {
        for (let k = 0; k < val.length; k++) {
          fd.append(Object.keys(data)[i], val[k]);
        }
      } else {
        fd.append(Object.keys(data)[i], val);
      }
    }

    if (dispatch && typeof dispatch === 'function')
      dispatch({type: actionTypes.pending});

    return axios.post(url, fd, {
      method: 'post',
      headers: {
        'Content-type': 'multipart/form-data',
      }
    })
      .then((res) => {
        return modifyResponse(res, dispatch, actionTypes)
      })
      .catch((err) => {
        error(err, dispatch, actionTypes.rejected);
        return Promise.reject();
      })
  },
};



// WEBPACK FOOTER //
// ./src/app/utils/request/index.js